// import React, { useState, useRef, useEffect } from "react";
// import axios from "axios";

// function BarcodeScan() {
//   const [barcode, setBarcode] = useState("");
//   const [scanCount, setScanCount] = useState(0);
//   const [scannedList, setScannedList] = useState([]);

//   const barcodeRef = useRef();

//   const successBeep = () => {
//     const audio = new Audio("/success.mp3");
//     audio.play();
//   };

//   const errorBeep = () => {
//     const audio = new Audio("/error.mp3");
//     audio.play();
//   };

//   useEffect(() => {
//     barcodeRef.current?.focus();
//   }, []);

//   const saveBarcode = async () => {
//     if (!barcode.trim()) return;

//     try {
//       const res = await axios.post(
//         "https://localhost:5001/api/barcode/save",
//         {
//           barcodeNo: barcode,
//         }
//       );

//       successBeep();

//       setScannedList((prev) => [res.data, ...prev]);
//       setScanCount((prev) => prev + 1);

//       setBarcode("");

//       barcodeRef.current.focus();
//     } catch (err) {
//       errorBeep();

//       alert(
//         err.response?.data || "Barcode already scanned"
//       );

//       setBarcode("");
//       barcodeRef.current.focus();
//     }
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//       saveBarcode();
//     }
//   };

//   return (
//     <div className="container mt-4">

//       <div className="card p-3">

//         <h3>Barcode Scanner</h3>

//         <h4>
//           Total Scan : {scanCount}
//         </h4>

//         <input
//           ref={barcodeRef}
//           type="text"
//           className="form-control form-control-lg"
//           placeholder="Scan Barcode Here"
//           value={barcode}
//           onChange={(e) => setBarcode(e.target.value)}
//           onKeyDown={handleKeyDown}
//         />

//       </div>

//       <table className="table table-bordered mt-3">
//         <thead>
//           <tr>
//             <th>ID</th>
//             <th>Barcode</th>
//             <th>Date</th>
//           </tr>
//         </thead>

//         <tbody>
//           {scannedList.map((item) => (
//             <tr key={item.id}>
//               <td>{item.id}</td>
//               <td>{item.barcodeNo}</td>
//               <td>{item.createdDate}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//     </div>
//   );
// }

// export default BarcodeScan;


// import React, { useState, useEffect } from "react";
// import axios from "axios";

// function BarcodeScanner() {
//   const [barcode, setBarcode] = useState("");
//   const [list, setList] = useState([]);

//   useEffect(() => {
//     let buffer = "";

//     const handleKeyPress = async (e) => {
//       if (e.key === "Enter") {
//         if (!buffer) return;

//         try {
//           const res = await axios.post(
//             "https://localhost:7038/api/Barcode/save",
//             {
//               barcodeNo: buffer,
//             }
//           );

//           setList((prev) => [res.data, ...prev]);

//           // Success Beep
//           new Audio("/success.mp3").play();
//         } catch {
//           new Audio("/error.mp3").play();
//         }

//         buffer = "";
//         setBarcode("");
//       } else {
//         buffer += e.key;
//         setBarcode(buffer);
//       }
//     };

//     window.addEventListener("keypress", handleKeyPress);

//     return () =>
//       window.removeEventListener(
//         "keypress",
//         handleKeyPress
//       );
//   }, []);

//   return (
//     <div className="container mt-3">
//       <h3>Barcode Scanner</h3>

//       <input
//         className="form-control form-control-lg"
//         value={barcode}
//         readOnly
//       />

//       <h5 className="mt-3">
//         Total Scan : {list.length}
//       </h5>

//       <table className="table table-bordered mt-3">
//         <thead>
//           <tr>
//             <th>Barcode</th>
//           </tr>
//         </thead>
//         <tbody>
//           {list.map((x) => (
//             <tr key={x.id}>
//               <td>{x.barcodeNo}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }

// export default BarcodeScanner;





// ONLY SCANN

// import React, { useState } from "react";
// import axios from "axios";

// function BarcodeScanner() {
//   const [barcode, setBarcode] = useState("");

//   // Success Beep
//   const playSuccessBeep = () => {
//     const ctx = new (window.AudioContext || window.webkitAudioContext)();

//     const beep = (freq, start, duration) => {
//       const osc = ctx.createOscillator();
//       const gain = ctx.createGain();

//       osc.frequency.value = freq;
//       osc.type = "sine";

//       osc.connect(gain);
//       gain.connect(ctx.destination);

//       gain.gain.value = 0.3;

//       osc.start(start);
//       osc.stop(start + duration);
//     };

//     const now = ctx.currentTime;

//     beep(1000, now, 0.08);
//     beep(1400, now + 0.1, 0.08);
//   };

//   // Error Beep
//   const playErrorBeep = () => {
//     const ctx = new (window.AudioContext || window.webkitAudioContext)();

//     const osc = ctx.createOscillator();
//     const gain = ctx.createGain();

//     osc.type = "square";
//     osc.frequency.value = 300;

//     osc.connect(gain);
//     gain.connect(ctx.destination);

//     gain.gain.value = 0.4;

//     osc.start();
//     osc.stop(ctx.currentTime + 0.4);
//   };

//   const saveBarcode = async () => {
//     if (!barcode.trim()) return;

//     try {
//       await axios.post("https://localhost:7038/api/Barcode/save", {
//         barcodeNo: barcode,
//       });

//       playSuccessBeep();

//       setBarcode("");
//     } catch (error) {
//       playErrorBeep();

//       alert(error.response?.data || "Barcode already scanned");
//     }
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//       saveBarcode();
//     }
//   };

//   return (
//     <div className="container mt-3">
//       <h3>Barcode Scanner</h3>

//       <input
//         type="text"
//         className="form-control form-control-lg"
//         placeholder="Scan Barcode"
//         value={barcode}
//         onChange={(e) => setBarcode(e.target.value)}
//         onKeyDown={handleKeyDown}
//         autoFocus
//       />
//     </div>
//   );
// }

// export default BarcodeScanner;

import React, { useState, useRef, useEffect } from "react";
import api from "../api/axios";
import { Html5Qrcode } from "html5-qrcode";

function BarcodeScanner() {
  
  const [cameraOpen, setCameraOpen] = useState(false);
const scannerRef = useRef(null);
  
  
  const [barcode, setBarcode] = useState("");
  const [scannedList, setScannedList] = useState([]);

  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  // ---------------- SUCCESS BEEP ----------------

  const playSuccessBeep = async () => {
    try {
      const AudioContext =
        window.AudioContext || window.webkitAudioContext;

      const ctx = new AudioContext();

      if (ctx.state === "suspended") {
        await ctx.resume();
      }

      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      osc.type = "sine";
      osc.frequency.setValueAtTime(1000, ctx.currentTime);

      gain.gain.setValueAtTime(0.5, ctx.currentTime);

      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.start();

      osc.stop(ctx.currentTime + 0.15);

      osc.onended = () => {
        ctx.close();
      };
    } catch (err) {
      console.log(err);
    }
  };

  // ---------------- ERROR BEEP ----------------

  const playErrorBeep = async () => {
    try {
      const AudioContext =
        window.AudioContext || window.webkitAudioContext;

      const ctx = new AudioContext();

      if (ctx.state === "suspended") {
        await ctx.resume();
      }

      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      osc.type = "square";
      osc.frequency.setValueAtTime(300, ctx.currentTime);

      gain.gain.setValueAtTime(0.5, ctx.currentTime);

      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.start();

      osc.stop(ctx.currentTime + 0.40);

      osc.onended = () => {
        ctx.close();
      };
    } catch (err) {
      console.log(err);
    }
  };

  // ---------------- SAVE BARCODE ----------------

  const saveBarcode = async () => {
    if (!barcode.trim()) return;

    try {
      const res = await api.post("/barcode/save", {
        barcodeNo: barcode,
      });

      await playSuccessBeep();

      setScannedList((prev) => [res.data, ...prev]);

      setBarcode("");

      inputRef.current?.focus();
    } catch (error) {
      await playErrorBeep();

      alert(error.response?.data || "Duplicate Barcode");

      setBarcode("");

      inputRef.current?.focus();
    }
  };
//scan 
const startScanner = async () => {
  setCameraOpen(true);

  setTimeout(async () => {
    try {
      scannerRef.current = new Html5Qrcode("reader");

      await scannerRef.current.start(
        { facingMode: "environment" }, // Back Camera
        {
          fps: 10,
          qrbox: 250,
        },
        async (decodedText) => {

          setBarcode(decodedText);

          await scannerRef.current.stop();
          await scannerRef.current.clear();

          setCameraOpen(false);

          try {
            const res = await api.post("/barcode/save", {
              barcodeNo: decodedText,
            });

            await playSuccessBeep();

            setScannedList((prev) => [res.data, ...prev]);
          } catch (err) {
            await playErrorBeep();
            alert(err.response?.data || "Duplicate Barcode");
          }
        },
        () => {}
      );
    } catch (err) {
      console.log(err);
    }
  }, 200);
};

const stopScanner = async () => {
  if (scannerRef.current) {
    await scannerRef.current.stop();
    await scannerRef.current.clear();
  }

  setCameraOpen(false);
};
//
  // ---------------- ENTER KEY ----------------

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      saveBarcode();
    }
  };

  return (
    <div className="container mt-4">

      <div className="card shadow">

        <div className="card-header">
          <h4>Barcode Scanner</h4>
        </div>

        <div className="card-body">

          <input
            ref={inputRef}
            type="text"
            className="form-control form-control-lg"
            placeholder="Scan Barcode"
            value={barcode}
            onChange={(e) => setBarcode(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          {cameraOpen && (
    <div
        id="reader"
        style={{
            width: "100%",
            maxWidth: "450px",
            marginTop: "20px"
        }}
    />
)}
<button
  className="btn btn-primary me-2"
  onClick={startScanner}
>
  📷 Scan Barcode
</button>

{cameraOpen && (
  <button
    className="btn btn-danger"
    onClick={stopScanner}
  >
    Close Camera
  </button>
)}


          <div className="mt-3">

            <strong>Total Scan : {scannedList.length}</strong>

          </div>

          <button
            className="btn btn-success mt-3 me-2"
            onClick={playSuccessBeep}
          >
            Test Success Beep
          </button>

          <button
            className="btn btn-danger mt-3"
            onClick={playErrorBeep}
          >
            Test Error Beep
          </button>

        </div>
      </div>

      <div className="card shadow mt-4">

        <div className="card-header">

          <strong>Scanned Barcode List</strong>

        </div>

        <div className="card-body">

          <table className="table table-bordered table-striped">

            <thead>

              <tr>

                <th>#</th>

                <th>Barcode</th>

                <th>Scan Time</th>

              </tr>

            </thead>

            <tbody>

              {scannedList.length > 0 ? (

                scannedList.map((item, index) => (

                  <tr key={index}>

                    <td>{index + 1}</td>

                    <td>{item.barcodeNo}</td>

                    <td>
                      {new Date(
                        item.createdDate || Date.now()
                      ).toLocaleTimeString()}
                    </td>

                  </tr>

                ))

              ) : (

                <tr>

                  <td colSpan="3" className="text-center">

                    No Barcode Scanned

                  </td>

                </tr>

              )}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}

export default BarcodeScanner;